// import React, { useEffect, useState } from "react";
// import { useSelector, useDispatch } from "react-redux";
// import * as XLSX from "xlsx";
// import useApi from "../../../CustomHooks/useApi";
// import { Search, Download, Printer } from "lucide-react";
// import { getDisplayDate } from "../../../ResuableCompoment/GetDisplayDate";
// import { openPrint } from "../../../Store/Slices/printSlice";
// import PrintPopup from "../../../ResuableCompoment/PrintPopup";
// import DynamicTable from "../../../ResuableCompoment/DynamicTable";

// const BbpsOnlineHistory1 = () => {
//     const mid = useSelector(
//         (state) => state.auth.employeeDetails?.username
//     );

//     const dispatch = useDispatch();

//     const { callApi: bbpsonlinehistory } = useApi(
//         "/bbps/history",
//         "GET"
//     );

//     const { callApi: raiseComplaintApi } = useApi(
//         "/bbps/complaint",
//         "POST"
//     );

//     const { callApi: txnStatusApi } = useApi(
//         "/bbps/txn-status",
//         "POST"
//     );

//     /* ================= STATES ================= */
//     const [history, setHistory] = useState([]);
//     const [isHistoryLoading, setIsHistoryLoading] = useState(false);
//     const [currentPage, setCurrentPage] = useState(1);
//     const recordsPerPage = 25;
//     const [searchTerm, setSearchTerm] = useState("");
//     const [selectedTxn, setSelectedTxn] = useState(null);
//     const [showComplaintModal, setShowComplaintModal] = useState(false);
//     const [statusResponse, setStatusResponse] = useState(null);
//     const [complaintResponse, setComplaintResponse] = useState(null);
//     const [showComplaintResponseModal, setShowComplaintResponseModal] = useState(false);

//     const getToday = () => new Date().toISOString().split("T")[0];

//     const [fromDate, setFromDate] = useState(getToday());
//     const [toDate, setToDate] = useState(getToday());

//     const [showStatusModal, setShowStatusModal] = useState(false);

//     /* ================= TABLE COLUMNS ================= */
//     const columns = [
//         {
//             key: "createdAt",
//             label: "Date / Time",
//             render: (v) => getDisplayDate(v),
//         },
//         {
//             key: "txnId",
//             label: "Transaction ID",
//         },
//         {
//             key: "amount",
//             label: "Amount",
//             render: (v) => (
//                 <span className="font-semibold text-slate-800">
//                     ₹{Number(v || 0).toFixed(2)}
//                 </span>
//             ),
//         },

//         {
//             key: "billerId",
//             label: "Biller Name",
//             render: (v) => v || "-",
//         },

//         {
//             key: "baRefId",
//             label: "Unique ID",
//             render: (v) => v || "-",
//         },

//         {
//             key: "status",
//             label: "Status",
//             render: (v) => (
//                 <span
//                     className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold
//                 ${v === "SUCCESS"
//                             ? "bg-emerald-100 text-emerald-700"
//                             : v === "PENDING"
//                                 ? "bg-amber-100 text-amber-700"
//                                 : "bg-rose-100 text-rose-700"
//                         }`}
//                 >
//                     {v}
//                 </span>
//             ),
//         },

//         {
//             key: "action",
//             label: "Action",
//             render: (_, row) => (
//                 <div className="flex flex-col gap-2">
//                     <button
//                         onClick={() => {
//                             setSelectedTxn(row);
//                             handleTxnStatus(row);
//                         }}
//                         className="px-3 py-1 rounded-lg bg-blue-100 text-blue-700 text-xs font-semibold"
//                     >
//                         Status Check
//                     </button>

//                     <button
//                         onClick={() => {
//                             setSelectedTxn(row);
//                             setShowComplaintModal(true);
//                         }}
//                         className="px-3 py-1 rounded-lg bg-red-100 text-red-700 text-xs font-semibold"
//                     >
//                         Raise Complaint
//                     </button>
//                 </div>
//             ),
//         },
//     ];

//     /* ================= FETCH HISTORY ================= */
//     const fetchHistory = async () => {
//         setIsHistoryLoading(true);
//         try {
//             let query = `?mid=${mid}`;

//             if (fromDate) query += `&fromDate=${fromDate}`;
//             if (toDate) query += `&toDate=${toDate}`;

//             const res = await bbpsonlinehistory(null, query);

//             console.log("BBPS History Response", res);

//             const historyData = res?.data || [];

//             const sorted = historyData.sort(
//                 (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
//             );

//             setHistory(sorted);
//         } catch (err) {
//             console.error(err);
//             alert("Failed to load BBPS Online history");
//         } finally {
//             setIsHistoryLoading(false);
//         }
//     };

//     useEffect(() => {
//         fetchHistory();
//         // eslint-disable-next-line
//     }, []);

//     /* ================= SEARCH + PAGINATION ================= */
//     const filteredRecords = history.filter((record) =>
//         Object.values(record).some((value) =>
//             String(value || "")
//                 .toLowerCase()
//                 .includes(searchTerm.toLowerCase())
//         )
//     );

//     const totalPages = Math.ceil(
//         filteredRecords.length / recordsPerPage
//     );

//     const indexOfLastRecord = currentPage * recordsPerPage;
//     const indexOfFirstRecord =
//         indexOfLastRecord - recordsPerPage;

//     const currentRecords = filteredRecords.slice(
//         indexOfFirstRecord,
//         indexOfLastRecord
//     );

//     /* ================= EXCEL DOWNLOAD ================= */
//     const downloadExcel = () => {
//         const rows = history.map((r) => ({
//             Date: r.createdAt,
//             TxnID: r.txnId,
//             Amount: r.amount,
//             Biller: r.billerName,
//             UniqueID: r.uniqueId,
//             AckNo: r.ackNo,
//             Status: r.status,
//         }));

//         const ws = XLSX.utils.json_to_sheet(rows);
//         const wb = XLSX.utils.book_new();

//         XLSX.utils.book_append_sheet(wb, ws, "CMS History");

//         XLSX.writeFile(wb, "CMS_History_Report.xlsx");
//     };

//     const handleTxnStatus = async (row) => {
//         try {
//             const payload = {
//                 trackingType: "TRANS_REF_ID",
//                 trackingValue: row.requestId,
//             };

//             const res = await txnStatusApi(payload);

//             console.log("Txn Status Response", res);

//             setStatusResponse(res?.data || res);
//             setShowStatusModal(true);
//         } catch (err) {
//             console.error(err);
//         }
//     };

//     const handleRaiseComplaint = async (row) => {
//         try {
//             const payload = {
//                 complaintType: "Transaction",
//                 complainDesc: "Bill paid but account not updated",
//                 txnRefId: row.requestId,
//                 complaintDisposition:
//                     "Transaction Successful, account not updated",
//             };

//             const res = await raiseComplaintApi(payload);

//             console.log("Complaint Response", res);

//             setComplaintResponse(res);
//             setShowComplaintResponseModal(true);
//             setShowComplaintModal(false);

//         } catch (err) {
//             console.error(err);

//             setComplaintResponse({
//                 success: false,
//                 message: err?.message || "Complaint Failed"
//             });

//             setShowComplaintResponseModal(true);
//         }
//     };

//     /* ================= UI ================= */
//     return (
//         <div className="min-h-screen p-6 bg-[#EEF1F5]">

//             {/* TITLE */}
//             <div className="mb-6">
//                 <h1 className="text-3xl font-bold text-[#0A2A4F]">
//                     BBPS Online Transaction Reports
//                 </h1>
//                 <p className="text-sm text-gray-600 mt-1">
//                     BBPS Online transaction history
//                 </p>
//             </div>

//             {/* FILTERS */}
//             <div className="bg-white rounded-2xl shadow-sm border p-6 mb-8">
//                 <div className="flex flex-wrap items-center gap-4">

//                     <div className="relative w-full md:w-80">
//                         <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
//                         <input
//                             type="text"
//                             placeholder="Search..."
//                             value={searchTerm}
//                             onChange={(e) => setSearchTerm(e.target.value)}
//                             className="w-full pl-10 pr-4 h-10 rounded-lg border"
//                         />
//                     </div>

//                     <input
//                         type="date"
//                         value={fromDate}
//                         onChange={(e) => setFromDate(e.target.value)}
//                         className="h-10 px-3 border rounded-lg bg-gray-50"
//                     />

//                     <input
//                         type="date"
//                         value={toDate}
//                         min={fromDate}
//                         onChange={(e) => setToDate(e.target.value)}
//                         className="h-10 px-3 border rounded-lg bg-gray-50"
//                     />

//                     <button
//                         onClick={() => {
//                             setCurrentPage(1);
//                             fetchHistory();
//                         }}
//                         className="h-10 px-5 rounded-lg bg-indigo-600 text-white"
//                     >
//                         Apply
//                     </button>

//                     <button
//                         onClick={downloadExcel}
//                         className="h-10 px-6 rounded-lg bg-green-600 text-white flex items-center gap-2"
//                     >
//                         <Download size={16} />
//                         Download Excel
//                     </button>

//                 </div>
//             </div>

//             {/* TABLE */}
//             {/* <div className="bg-white p-8 rounded-2xl shadow-md"> */}
//             <div className="bg-white rounded-2xl shadow-md">
//                 <DynamicTable
//                     columns={columns}
//                     data={currentRecords}
//                     isLoading={isHistoryLoading}
//                     emptyText="No CMS records found"
//                 />
//             </div>

//             {showComplaintModal && (
//                 <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
//                     <div className="bg-white rounded-xl p-6 w-[500px]">
//                         <h3 className="font-bold text-lg mb-4">
//                             Raise Complaint
//                         </h3>

//                         <p className="text-sm mb-4">
//                             Transaction Ref ID:
//                             <b>{selectedTxn?.requestId}</b>
//                         </p>

//                         <div className="flex justify-end gap-3">
//                             <button
//                                 onClick={() => setShowComplaintModal(false)}
//                                 className="px-4 py-2 border rounded-lg"
//                             >
//                                 Cancel
//                             </button>

//                             <button
//                                 onClick={() => handleRaiseComplaint(selectedTxn)}
//                                 className="px-4 py-2 bg-red-600 text-white rounded-lg"
//                             >
//                                 Submit Complaint
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             )}

//             {/* PAGINATION */}
//             {filteredRecords.length > recordsPerPage && (
//                 <div className="mt-6 flex justify-between text-sm">

//                     <span>
//                         Page <b>{currentPage}</b> of <b>{totalPages}</b>
//                     </span>

//                     <div className="flex gap-3">
//                         <button
//                             disabled={currentPage === 1}
//                             onClick={() => setCurrentPage((p) => p - 1)}
//                             className="px-4 py-2 bg-gray-200 rounded-lg"
//                         >
//                             Previous
//                         </button>

//                         <button
//                             disabled={currentPage === totalPages}
//                             onClick={() => setCurrentPage((p) => p + 1)}
//                             className="px-4 py-2 bg-[#0A2A4F] text-white rounded-lg"
//                         >
//                             Next
//                         </button>
//                     </div>

//                 </div>
//             )}

//             {showStatusModal && statusResponse && (
//                 <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
//                     <div className="bg-white rounded-2xl p-6 w-[650px] max-h-[80vh] overflow-auto">
//                         <div className="flex items-center justify-between mb-4">
//                             <h3 className="text-lg font-bold">
//                                 Transaction Status
//                             </h3>

//                             <button
//                                 onClick={() => setShowStatusModal(false)}
//                                 className="text-red-600 font-bold"
//                             >
//                                 ✕
//                             </button>
//                         </div>

//                         <div className="space-y-3 text-sm">
//                             <div>
//                                 <strong>Transaction ID :</strong>{" "}
//                                 {statusResponse?.txnId}
//                             </div>

//                             <div>
//                                 <strong>Request ID :</strong>{" "}
//                                 {statusResponse?.requestId}
//                             </div>

//                             <div>
//                                 <strong>Unique ID :</strong>{" "}
//                                 {statusResponse?.baRefId}
//                             </div>

//                             <div>
//                                 <strong>Biller ID :</strong>{" "}
//                                 {statusResponse?.billerId}
//                             </div>

//                             <div>
//                                 <strong>Consumer Number :</strong>{" "}
//                                 {statusResponse?.consumerNumber}
//                             </div>

//                             <div>
//                                 <strong>Amount :</strong> ₹
//                                 {statusResponse?.amount}
//                             </div>

//                             <div>
//                                 <strong>Status :</strong>{" "}
//                                 <span className="font-semibold text-green-600">
//                                     {statusResponse?.status}
//                                 </span>
//                             </div>

//                             <div>
//                                 <strong>Created At :</strong>{" "}
//                                 {getDisplayDate(statusResponse?.createdAt)}
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             )}

//             {showComplaintResponseModal && (
//                 <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
//                     <div className="bg-white rounded-2xl shadow-xl w-full max-w-lg p-6">

//                         <div className="flex items-center justify-between mb-5">
//                             <h2 className="text-xl font-bold text-[#0A2A4F]">
//                                 Complaint Response
//                             </h2>

//                             <button
//                                 onClick={() => {
//                                     setShowComplaintResponseModal(false);
//                                     setComplaintResponse(null);
//                                 }}
//                                 className="text-red-600 text-xl font-bold"
//                             >
//                                 ×
//                             </button>
//                         </div>

//                         <div className="space-y-4">

//                             <div>
//                                 <p className="text-xs text-gray-500">
//                                     Status
//                                 </p>

//                                 <span
//                                     className={`inline-flex px-3 py-1 rounded-full text-xs font-semibold ${complaintResponse?.success
//                                             ? "bg-green-100 text-green-700"
//                                             : "bg-red-100 text-red-700"
//                                         }`}
//                                 >
//                                     {complaintResponse?.success ? "SUCCESS" : "FAILED"}
//                                 </span>
//                             </div>

//                             <div>
//                                 <p className="text-xs text-gray-500">
//                                     Message
//                                 </p>

//                                 <p className="font-semibold">
//                                     {complaintResponse?.message || "-"}
//                                 </p>
//                             </div>

//                             {complaintResponse?.data?.complaintId && (
//                                 <div>
//                                     <p className="text-xs text-gray-500">
//                                         Complaint ID
//                                     </p>

//                                     <p className="font-semibold">
//                                         {complaintResponse.data.complaintId}
//                                     </p>
//                                 </div>
//                             )}

//                             {complaintResponse?.data?.requestId && (
//                                 <div>
//                                     <p className="text-xs text-gray-500">
//                                         Request ID
//                                     </p>

//                                     <p className="font-semibold">
//                                         {complaintResponse.data.requestId}
//                                     </p>
//                                 </div>
//                             )}

//                         </div>

//                         <div className="flex justify-end mt-6">
//                             <button
//                                 onClick={() => {
//                                     setShowComplaintResponseModal(false);
//                                     setComplaintResponse(null);
//                                 }}
//                                 className="px-5 py-2 rounded-lg bg-[#0A2A4F] text-white"
//                             >
//                                 Close
//                             </button>
//                         </div>

//                     </div>
//                 </div>
//             )}

//             <PrintPopup />
//         </div>
//     );
// };

// export default BbpsOnlineHistory1;

import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import * as XLSX from "xlsx";
import useApi from "../../../CustomHooks/useApi";
import { 
  Search, 
  FileSpreadsheet, 
  RotateCw, 
  CheckCircle2, 
  XCircle, 
  Clock, 
  ChevronLeft, 
  ChevronRight,
  ShieldAlert,
  HelpCircle,
  X,
  Layers,
  Activity,
  AlertTriangle
} from "lucide-react";
import { getDisplayDate } from "../../../ResuableCompoment/GetDisplayDate";
import PrintPopup from "../../../ResuableCompoment/PrintPopup";
import DynamicTable from "../../../ResuableCompoment/DynamicTable";

const BbpsOnlineHistory1 = () => {
  const mid = useSelector((state) => state.auth.employeeDetails?.username);
  const dispatch = useDispatch();

  const { callApi: bbpsonlinehistory } = useApi("/bbps/history", "GET");
  const { callApi: raiseComplaintApi } = useApi("/bbps/complaint", "POST");
  const { callApi: txnStatusApi } = useApi("/bbps/txn-status", "POST");

  /* ================= STATES ================= */
  const [history, setHistory] = useState([]);
  const [isHistoryLoading, setIsHistoryLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 25;
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedTxn, setSelectedTxn] = useState(null);
  const [showComplaintModal, setShowComplaintModal] = useState(false);
  const [statusResponse, setStatusResponse] = useState(null);
  const [complaintResponse, setComplaintResponse] = useState(null);
  const [showComplaintResponseModal, setShowComplaintResponseModal] = useState(false);
  const [showStatusModal, setShowStatusModal] = useState(false);

  const getToday = () => new Date().toISOString().split("T")[0];

  const [fromDate, setFromDate] = useState(getToday());
  const [toDate, setToDate] = useState(getToday());

  /* ================= TABLE COLUMNS ================= */
  const columns = [
    {
      key: "createdAt",
      label: "Date / Time",
      render: (v) => getDisplayDate(v),
    },
    {
      key: "txnId",
      label: "Transaction ID",
      render: (v) => (
        <span className="font-mono text-slate-700 bg-slate-100/70 px-2 py-0.5 rounded-md border border-slate-200/50">
          {v || "—"}
        </span>
      ),
    },
    {
      key: "amount",
      label: "Amount",
      render: (v) => (
        <span className="font-bold text-slate-900 text-sm">
          ₹{Number(v || 0).toFixed(2)}
        </span>
      ),
    },
    {
      key: "billerId",
      label: "Biller Name",
      render: (v) => (
        <span className="font-semibold text-slate-800">
          {v || "—"}
        </span>
      ),
    },
    {
      key: "baRefId",
      label: "Unique ID",
      render: (v) => (
        <span className="font-mono text-slate-500">
          {v || "—"}
        </span>
      ),
    },
    {
      key: "status",
      label: "Status",
      render: (v) => {
        const status = (v || "").toUpperCase();
        if (status === "SUCCESS") {
          return (
            <span className="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-[11px] font-semibold bg-emerald-50 text-emerald-700 border border-emerald-200">
              <CheckCircle2 className="w-3 h-3" /> SUCCESS
            </span>
          );
        }
        if (status === "FAILED" || status === "FAILURE") {
          return (
            <span className="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-[11px] font-semibold bg-rose-50 text-rose-700 border border-rose-200">
              <XCircle className="w-3 h-3" /> FAILED
            </span>
          );
        }
        return (
          <span className="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-[11px] font-semibold bg-amber-50 text-amber-700 border border-amber-200">
            <Clock className="w-3 h-3" /> {status || "PENDING"}
          </span>
        );
      },
    },
    {
      key: "action",
      label: "Actions",
      render: (_, row) => (
        <div className="flex items-center gap-1.5">
          <button
            onClick={() => {
              setSelectedTxn(row);
              handleTxnStatus(row);
            }}
            className="px-2.5 py-1.5 rounded-xl bg-blue-50 hover:bg-blue-100 text-blue-700 border border-blue-200/60 text-[11px] font-bold transition active:scale-95 cursor-pointer flex items-center gap-1"
            title="Check Real-time Status"
          >
            <Activity className="w-3 h-3" />
            <span>Status</span>
          </button>

          <button
            onClick={() => {
              setSelectedTxn(row);
              setShowComplaintModal(true);
            }}
            className="px-2.5 py-1.5 rounded-xl bg-rose-50 hover:bg-rose-100 text-rose-700 border border-rose-200/60 text-[11px] font-bold transition active:scale-95 cursor-pointer flex items-center gap-1"
            title="Raise a Dispute Ticket"
          >
            <AlertTriangle className="w-3 h-3" />
            <span>Dispute</span>
          </button>
        </div>
      ),
    },
  ];

  /* ================= FETCH HISTORY ================= */
  const fetchHistory = async () => {
    setIsHistoryLoading(true);
    try {
      let query = `?mid=${mid}`;

      if (fromDate) query += `&fromDate=${fromDate}`;
      if (toDate) query += `&toDate=${toDate}`;

      const res = await bbpsonlinehistory(null, query);
      const historyData = res?.data || [];
      const sorted = historyData.sort(
        (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
      );

      setHistory(sorted);
      setCurrentPage(1);
    } catch (err) {
      console.error(err);
      alert("Failed to load BBPS Online history");
    } finally {
      setIsHistoryLoading(false);
    }
  };

  useEffect(() => {
    fetchHistory();
    // eslint-disable-next-line
  }, []);

  /* ================= SEARCH + PAGINATION ================= */
  const filteredRecords = history.filter((record) =>
    Object.values(record).some((value) =>
      String(value || "")
        .toLowerCase()
        .includes(searchTerm.toLowerCase())
    )
  );

  const totalPages = Math.ceil(filteredRecords.length / recordsPerPage) || 1;
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = filteredRecords.slice(
    indexOfFirstRecord,
    indexOfLastRecord
  );

  /* ================= EXCEL DOWNLOAD ================= */
  const downloadExcel = () => {
    const rows = history.map((r) => ({
      Date: r.createdAt,
      TxnID: r.txnId,
      Amount: r.amount,
      Biller: r.billerName,
      UniqueID: r.uniqueId,
      AckNo: r.ackNo,
      Status: r.status,
    }));

    const ws = XLSX.utils.json_to_sheet(rows);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "BBPS Online History");
    XLSX.writeFile(wb, "BBPS_Online_History_Report.xlsx");
  };

  const handleTxnStatus = async (row) => {
    try {
      const payload = {
        trackingType: "TRANS_REF_ID",
        trackingValue: row.requestId,
      };

      const res = await txnStatusApi(payload);
      setStatusResponse(res?.data || res);
      setShowStatusModal(true);
    } catch (err) {
      console.error(err);
    }
  };

  const handleRaiseComplaint = async (row) => {
    try {
      const payload = {
        complaintType: "Transaction",
        complainDesc: "Bill paid but account not updated",
        txnRefId: row.requestId,
        complaintDisposition: "Transaction Successful, account not updated",
      };

      const res = await raiseComplaintApi(payload);
      setComplaintResponse(res);
      setShowComplaintResponseModal(true);
      setShowComplaintModal(false);
    } catch (err) {
      console.error(err);
      setComplaintResponse({
        success: false,
        message: err?.message || "Complaint submission failed",
      });
      setShowComplaintResponseModal(true);
    }
  };

  return (
    <div className="space-y-6">
      {/* ================= SECTION HEADER ================= */}
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <div>
          <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold bg-blue-50 text-blue-700 border border-blue-100 mb-2">
            <Layers className="w-3.5 h-3.5" />
            Bharat Bill Payment System (BBPS) Online Log
          </div>
          <h2 className="text-xl sm:text-2xl font-bold text-slate-800 tracking-tight">
            BBPS Online Transaction Reports
          </h2>
          <p className="text-xs text-slate-500 font-medium mt-0.5">
            Audit live BBPS transactions, verify switch response callbacks, and lodge support tickets
          </p>
        </div>
      </div>

      {/* ================= FILTER & SEARCH BAR ================= */}
      <div className="bg-white rounded-3xl p-5 border border-slate-200/80 shadow-xs space-y-4">
        <div className="flex flex-wrap items-center justify-between gap-4">
          
          {/* Search Field */}
          <div className="relative w-full sm:w-80">
            <Search className="w-4 h-4 absolute left-3.5 top-1/2 -translate-y-1/2 text-slate-400" />
            <input
              type="text"
              placeholder="Search Txn ID, Biller, Unique ID..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full pl-10 pr-4 py-2.5 bg-slate-50 border border-slate-200/80 focus:border-blue-500 focus:bg-white rounded-xl text-xs font-semibold text-slate-700 placeholder-slate-400 outline-hidden transition"
            />
          </div>

          {/* Date Picker & Action Buttons */}
          <div className="flex flex-wrap items-center gap-2.5 w-full sm:w-auto">
            <div className="flex items-center gap-2">
              <input
                type="date"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
                className="h-10 px-3 bg-slate-50 border border-slate-200/80 focus:border-blue-500 focus:bg-white rounded-xl text-xs font-semibold text-slate-700 outline-hidden transition"
              />
              <span className="text-slate-400 text-xs font-bold">to</span>
              <input
                type="date"
                value={toDate}
                min={fromDate}
                onChange={(e) => setToDate(e.target.value)}
                className="h-10 px-3 bg-slate-50 border border-slate-200/80 focus:border-blue-500 focus:bg-white rounded-xl text-xs font-semibold text-slate-700 outline-hidden transition"
              />
            </div>

            <button
              onClick={() => {
                setCurrentPage(1);
                fetchHistory();
              }}
              disabled={isHistoryLoading}
              className="h-10 px-4 rounded-xl bg-slate-900 hover:bg-slate-800 text-white font-bold text-xs shadow-md shadow-slate-900/10 transition active:scale-95 flex items-center gap-1.5"
            >
              <RotateCw className={`w-3.5 h-3.5 ${isHistoryLoading ? "animate-spin" : ""}`} />
              <span>Apply</span>
            </button>

            <button
              onClick={downloadExcel}
              className="h-10 px-4 rounded-xl bg-emerald-600 hover:bg-emerald-700 text-white font-bold text-xs shadow-md shadow-emerald-600/15 transition active:scale-95 flex items-center gap-1.5"
            >
              <FileSpreadsheet className="w-3.5 h-3.5" />
              <span>Excel</span>
            </button>
          </div>
        </div>

        {/* Count Preview Bar */}
        <div className="pt-2 border-t border-slate-100 flex items-center justify-between text-xs text-slate-500 font-medium">
          <span>
            Showing <strong className="text-slate-800">{currentRecords.length}</strong> of{" "}
            <strong className="text-slate-800">{filteredRecords.length}</strong> online transactions
          </span>
          <span>
            Page <strong className="text-blue-600 font-bold">{currentPage}</strong> of{" "}
            <strong>{totalPages}</strong>
          </span>
        </div>
      </div>

      {/* ================= TABLE CONTAINER ================= */}
      <div className="bg-white rounded-3xl border border-slate-200/80 shadow-xs p-2 sm:p-4">
        <DynamicTable
          columns={columns}
          data={currentRecords}
          isLoading={isHistoryLoading}
          emptyText="No BBPS Online records found for this period"
        />

        {/* ================= PAGINATION CONTROLS ================= */}
        {filteredRecords.length > recordsPerPage && (
          <div className="mt-4 pt-3 border-t border-slate-100 flex flex-wrap items-center justify-between gap-4 text-xs font-semibold text-slate-600 px-2">
            <span>
              Page {currentPage} of {totalPages}
            </span>

            <div className="flex items-center gap-2">
              <button
                disabled={currentPage === 1}
                onClick={() => setCurrentPage((p) => p - 1)}
                className="px-3 py-1.5 rounded-xl border border-slate-200 bg-white hover:bg-slate-50 text-slate-700 disabled:opacity-40 transition active:scale-95 flex items-center gap-1"
              >
                <ChevronLeft className="w-3.5 h-3.5" />
                <span>Prev</span>
              </button>

              <button
                disabled={currentPage === totalPages}
                onClick={() => setCurrentPage((p) => p + 1)}
                className="px-3 py-1.5 rounded-xl bg-slate-900 hover:bg-slate-800 text-white disabled:opacity-40 transition active:scale-95 flex items-center gap-1"
              >
                <span>Next</span>
                <ChevronRight className="w-3.5 h-3.5" />
              </button>
            </div>
          </div>
        )}
      </div>

      {/* ================= RAISE COMPLAINT MODAL ================= */}
      {showComplaintModal && (
        <div className="fixed inset-0 bg-slate-950/60 backdrop-blur-xs flex items-center justify-center z-50 p-4 animate-in fade-in duration-150">
          <div className="bg-white rounded-3xl p-6 sm:p-7 w-full max-w-md shadow-2xl border border-slate-100 space-y-5 animate-in zoom-in-95 duration-150">
            <div className="flex items-start justify-between">
              <div className="flex items-center gap-3">
                <div className="p-2.5 rounded-2xl bg-rose-50 text-rose-600 border border-rose-100">
                  <ShieldAlert className="w-5 h-5" />
                </div>
                <div>
                  <h3 className="text-base font-bold text-slate-900">
                    Lodge Dispute Ticket
                  </h3>
                  <p className="text-xs text-slate-500 font-medium">
                    Submit a formal grievance to the biller network
                  </p>
                </div>
              </div>
              <button
                onClick={() => setShowComplaintModal(false)}
                className="p-1 rounded-xl text-slate-400 hover:text-slate-600 hover:bg-slate-100 transition"
              >
                <X className="w-4 h-4" />
              </button>
            </div>

            <div className="bg-slate-50 rounded-2xl p-4 border border-slate-200/80 space-y-2 text-xs">
              <div className="flex justify-between">
                <span className="text-slate-500 font-medium">Request Ref ID:</span>
                <span className="font-mono font-bold text-slate-800">{selectedTxn?.requestId || "—"}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-slate-500 font-medium">Biller Name:</span>
                <span className="font-semibold text-slate-800">{selectedTxn?.billerId || "—"}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-slate-500 font-medium">Dispute Reason:</span>
                <span className="font-semibold text-rose-600">Bill paid but account not updated</span>
              </div>
            </div>

            <div className="flex justify-end gap-2.5 pt-2">
              <button
                onClick={() => setShowComplaintModal(false)}
                className="px-4 py-2.5 rounded-xl border border-slate-200 text-slate-700 text-xs font-bold hover:bg-slate-50 transition active:scale-95"
              >
                Cancel
              </button>
              <button
                onClick={() => handleRaiseComplaint(selectedTxn)}
                className="px-5 py-2.5 rounded-xl bg-rose-600 hover:bg-rose-700 text-white text-xs font-bold shadow-md shadow-rose-600/20 transition active:scale-95 cursor-pointer"
              >
                Confirm & Lodge
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ================= REAL-TIME STATUS CHECK MODAL ================= */}
      {showStatusModal && statusResponse && (
        <div className="fixed inset-0 bg-slate-950/60 backdrop-blur-xs flex items-center justify-center z-50 p-4 animate-in fade-in duration-150">
          <div className="bg-white rounded-3xl p-6 sm:p-7 w-full max-w-lg shadow-2xl border border-slate-100 space-y-5 animate-in zoom-in-95 duration-150">
            <div className="flex items-center justify-between pb-3 border-b border-slate-100">
              <div className="flex items-center gap-2.5">
                <div className="p-2 rounded-xl bg-blue-50 text-blue-600">
                  <Activity className="w-4 h-4" />
                </div>
                <div>
                  <h3 className="text-base font-bold text-slate-900 leading-none">
                    Real-time Transaction Status
                  </h3>
                  <p className="text-[11px] text-slate-400 font-medium mt-1">Live gateway switch verification</p>
                </div>
              </div>
              <button
                onClick={() => setShowStatusModal(false)}
                className="p-1 rounded-xl text-slate-400 hover:text-slate-600 hover:bg-slate-100 transition"
              >
                <X className="w-4 h-4" />
              </button>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-xs">
              <div className="p-3 bg-slate-50 rounded-xl border border-slate-200/70">
                <p className="text-[10px] uppercase font-bold text-slate-400">Transaction ID</p>
                <p className="font-mono font-bold text-slate-800 mt-0.5">{statusResponse?.txnId || "—"}</p>
              </div>

              <div className="p-3 bg-slate-50 rounded-xl border border-slate-200/70">
                <p className="text-[10px] uppercase font-bold text-slate-400">Request ID</p>
                <p className="font-mono font-bold text-slate-800 mt-0.5">{statusResponse?.requestId || "—"}</p>
              </div>

              <div className="p-3 bg-slate-50 rounded-xl border border-slate-200/70">
                <p className="text-[10px] uppercase font-bold text-slate-400">Unique Ref ID</p>
                <p className="font-mono font-bold text-slate-800 mt-0.5">{statusResponse?.baRefId || "—"}</p>
              </div>

              <div className="p-3 bg-slate-50 rounded-xl border border-slate-200/70">
                <p className="text-[10px] uppercase font-bold text-slate-400">Biller ID</p>
                <p className="font-semibold text-slate-800 mt-0.5">{statusResponse?.billerId || "—"}</p>
              </div>

              <div className="p-3 bg-slate-50 rounded-xl border border-slate-200/70">
                <p className="text-[10px] uppercase font-bold text-slate-400">Consumer Number</p>
                <p className="font-mono font-bold text-slate-800 mt-0.5">{statusResponse?.consumerNumber || "—"}</p>
              </div>

              <div className="p-3 bg-slate-50 rounded-xl border border-slate-200/70">
                <p className="text-[10px] uppercase font-bold text-slate-400">Amount</p>
                <p className="font-bold text-slate-900 mt-0.5">₹{Number(statusResponse?.amount || 0).toFixed(2)}</p>
              </div>
            </div>

            <div className="p-3.5 bg-emerald-50/70 border border-emerald-200 rounded-2xl flex items-center justify-between">
              <div>
                <p className="text-[10px] font-bold uppercase text-emerald-600">Switch Status</p>
                <p className="text-sm font-extrabold text-emerald-800">{statusResponse?.status || "SUCCESS"}</p>
              </div>
              <span className="text-[11px] text-emerald-700 font-medium">{getDisplayDate(statusResponse?.createdAt)}</span>
            </div>

            <div className="flex justify-end pt-2">
              <button
                onClick={() => setShowStatusModal(false)}
                className="px-5 py-2.5 rounded-xl bg-slate-900 text-white text-xs font-bold hover:bg-slate-800 transition active:scale-95"
              >
                Close Verification
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ================= COMPLAINT RESPONSE MODAL ================= */}
      {showComplaintResponseModal && (
        <div className="fixed inset-0 bg-slate-950/60 backdrop-blur-xs flex items-center justify-center z-50 p-4 animate-in fade-in duration-150">
          <div className="bg-white rounded-3xl p-6 sm:p-7 w-full max-w-md shadow-2xl border border-slate-100 space-y-5 animate-in zoom-in-95 duration-150">
            <div className="flex items-center justify-between pb-3 border-b border-slate-100">
              <h2 className="text-base font-bold text-slate-900">
                Dispute Ticket Response
              </h2>
              <button
                onClick={() => {
                  setShowComplaintResponseModal(false);
                  setComplaintResponse(null);
                }}
                className="p-1 rounded-xl text-slate-400 hover:text-slate-600 hover:bg-slate-100 transition"
              >
                <X className="w-4 h-4" />
              </button>
            </div>

            <div className="space-y-3.5 text-xs">
              <div className="flex items-center justify-between p-3 bg-slate-50 rounded-xl border border-slate-200/70">
                <span className="text-slate-500 font-medium">Acknowledgment:</span>
                <span
                  className={`inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-[11px] font-bold ${
                    complaintResponse?.success
                      ? "bg-emerald-100 text-emerald-800"
                      : "bg-rose-100 text-rose-800"
                  }`}
                >
                  {complaintResponse?.success ? <CheckCircle2 className="w-3 h-3" /> : <XCircle className="w-3 h-3" />}
                  {complaintResponse?.success ? "LODGED" : "FAILED"}
                </span>
              </div>

              <div className="p-3 bg-slate-50 rounded-xl border border-slate-200/70">
                <p className="text-slate-400 text-[10px] uppercase font-bold">Network Message</p>
                <p className="font-semibold text-slate-800 mt-0.5">{complaintResponse?.message || "—"}</p>
              </div>

              {complaintResponse?.data?.complaintId && (
                <div className="p-3 bg-blue-50/70 border border-blue-200 rounded-xl">
                  <p className="text-blue-500 text-[10px] uppercase font-bold">Complaint Ticket ID</p>
                  <p className="font-mono font-bold text-blue-900 mt-0.5">{complaintResponse.data.complaintId}</p>
                </div>
              )}

              {complaintResponse?.data?.requestId && (
                <div className="p-3 bg-slate-50 rounded-xl border border-slate-200/70">
                  <p className="text-slate-400 text-[10px] uppercase font-bold">Request ID</p>
                  <p className="font-mono font-semibold text-slate-800 mt-0.5">{complaintResponse.data.requestId}</p>
                </div>
              )}
            </div>

            <div className="flex justify-end pt-2">
              <button
                onClick={() => {
                  setShowComplaintResponseModal(false);
                  setComplaintResponse(null);
                }}
                className="px-5 py-2.5 rounded-xl bg-slate-900 text-white text-xs font-bold hover:bg-slate-800 transition active:scale-95"
              >
                Dismiss
              </button>
            </div>
          </div>
        </div>
      )}

      <PrintPopup />
    </div>
  );
};

export default BbpsOnlineHistory1;